import { useEffect, useState } from 'react';
import { authAPI } from '../services/api';

/**
 * Next generated Student ID + Unix username (does not reserve them).
 */
export function useStudentIdPreview({
  enabled,
  courseId,
  courseCategoryId,
  programType,
  modeOfCourse,
  locationOfCenter,
  heardFromId,
  firstName,
  lastName,
  batchId,
  batchStartDate,
  veStudentId,
} = {}) {
  const [previewId, setPreviewId] = useState('');
  const [previewUnixUsername, setPreviewUnixUsername] = useState('');
  const [previewBatchId, setPreviewBatchId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setPreviewId('');
      setPreviewUnixUsername('');
      setPreviewBatchId('');
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await authAPI.previewStudentId({
          courseId: courseId || undefined,
          courseCategoryId: courseCategoryId || undefined,
          programType: programType || undefined,
          modeOfCourse: modeOfCourse || undefined,
          locationOfCenter: locationOfCenter || undefined,
          heardFromId: heardFromId || undefined,
          firstName: firstName || undefined,
          lastName: lastName || undefined,
          batchId: batchId || undefined,
          batchStartDate: batchStartDate || undefined,
          veStudentId: veStudentId || undefined,
        });
        if (!cancelled) {
          setPreviewId(String(res.data?.data?.veStudentId || '').trim());
          setPreviewUnixUsername(String(res.data?.data?.unixUsername || '').trim());
          setPreviewBatchId(String(batchId || ''));
        }
      } catch {
        if (!cancelled) {
          setPreviewId('');
          setPreviewUnixUsername('');
          setPreviewBatchId('');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 250);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [
    enabled,
    courseId,
    courseCategoryId,
    programType,
    modeOfCourse,
    locationOfCenter,
    heardFromId,
    firstName,
    lastName,
    batchId,
    batchStartDate,
    veStudentId,
  ]);

  return { previewId, previewUnixUsername, previewBatchId, loading };
}
